import React from 'react';
import PropTypes from 'prop-types';
import Block from '../../../block/Block';
import CmsContent from '../../CmsContent';
export var Sidebar = function Sidebar(_ref) {
  var data = _ref.data;

  var _ref2 = data || {},
      _ref2$component = _ref2.component;

  _ref2$component = _ref2$component === void 0 ? {} : _ref2$component;
  var metadata = _ref2$component.metadata,
      _ref2$component$conte = _ref2$component.content;
  _ref2$component$conte = _ref2$component$conte === void 0 ? {} : _ref2$component$conte;
  var smallTitle = _ref2$component$conte.small_title,
      smallText = _ref2$component$conte.small_text,
      cta = _ref2$component$conte.cta,
      iconSmartPhone = _ref2$component$conte.icon_smartphone;

  var _ref3 = metadata || {},
      visualcta = _ref3.visualcta,
      _ref3$background = _ref3.background;

  _ref3$background = _ref3$background === void 0 ? {} : _ref3$background;
  var backgroundColor = _ref3$background.Key;
  var SideBarContent = /*#__PURE__*/React.createElement(React.Fragment, null, iconSmartPhone && /*#__PURE__*/React.createElement(CmsContent, {
    "data-en": 'cms-sidebar-image',
    content: iconSmartPhone
  }), smallTitle && /*#__PURE__*/React.createElement(CmsContent, {
    "data-en": 'cms-sidebar-title',
    content: smallTitle,
    textNodeWrapperElement: 'h3'
  }), smallText && /*#__PURE__*/React.createElement(CmsContent, {
    content: smallText,
    textNodeWrapperElement: 'p'
  }));
  return /*#__PURE__*/React.createElement(Block, {
    "data-en": 'cms-sidebar',
    className: backgroundColor
  }, !visualcta && cta ? /*#__PURE__*/React.createElement(CmsContent, {
    "data-en": 'cms-sidebar-cta',
    content: cta
  }, SideBarContent) : /*#__PURE__*/React.createElement(React.Fragment, null, SideBarContent, cta && /*#__PURE__*/React.createElement(CmsContent, {
    "data-en": 'cms-sidebar-cta',
    content: cta
  })));
};
Sidebar.propTypes = {
  data: PropTypes.object.isRequired
};
export default Sidebar;